import React from 'react';
import { Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';
import * as Api from '../../utils/api';
import Http from '../../utils/http';
import CommonNav from '../../components/goBack';
import Utils from '../../utils/utils';

const HttpInstance = new Http();
const utils = new Utils();
export default class BindPhone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scaleH: 0,
      phoneNumber: '',
    };
  }
  render() {
    const _this = this;
    return (
      <div className="bindContainer" style={{ minHeight: _this.state.scaleH }}>
        <CommonNav history={_this.props.history}></CommonNav>
        <h1 className="pageTitle">绑定手机号码</h1>
        <p className="page-tips">根据国家实名制要求，请先绑定手机号码</p>
        <div className="bind-iptcontianer">
          <div className="prefix">+86</div>
          <div className="ipt">
            <input
              // type="number"
              placeholder="请输入您的手机号码"
              value={_this.state.phoneNumber}
              onChange={_this.inputPhone.bind(_this)}
              maxLength={11}
            />
          </div>
          <div
            className="clear-ipt"
            onClick={_this.clearInputPhone.bind(_this)}
          >
            <img src={require('../../assets/images/search_closs.png')} />
          </div>
        </div>
        <div className="submitContainer">
          <button
            className="btn btn-block btn-sure"
            onClick={_this.bindPhone.bind(_this)}
          >
            确定
          </button>
          <p className="submit-tips">点击确定,即表示已阅读并同意</p>
          <Link to="/agree" className="registerRules">
            《用户注册协议》
          </Link>
        </div>
      </div>
    );
  }
  componentWillMount() {
    const _this = this;
    document.title = '绑定手机号码';
    _this.setState({
      scaleH: window.innerHeight + 'px',
    });
    let isApp = HttpInstance.getSearchByName(
      this.props.location.search,
      'isApp'
    );
    if (!isApp) {
      utils.wxShareConfig(_this, isApp);
    }
  }
  /**
   * 输入手机号码
   * */
  inputPhone(event) {
    const _this = this;
    if (isNaN(event.target.value)) {
      _this.setState({
        phoneNumber: _this.state.phoneNumber,
      });
    } else {
      _this.setState({
        phoneNumber: event.target.value,
      });
    }
  }
  /**
   * 清除手机号码
   * */
  clearInputPhone() {
    const _this = this;
    _this.setState({
      phoneNumber: '',
    });
  }
  /**
   * 绑定手机号码 */
  bindPhone() {
    const _this = this;
    let phoneNumber = _this.state.phoneNumber;
    if (!phoneNumber) {
      Toast.info('请输入手机号码后提交', 1);
      return false;
    } else {
      if (!/^1[345678]\d{9}$/.test(phoneNumber)) {
        Toast.info('请输正确的手机号码后提交', 1);
        return false;
      } else {
        let params = {};
        let response = HttpInstance.get(
          Api.QUERY_ISBINDPHONEFORWX_API + '?phoneNo=' + phoneNumber,
          params
        );
        response.then((data) => {
          let responseData = data.data;
          if (responseData.result) {
            _this.props.history.push({
              pathname: '/verification',
              search: '?phone=' + phoneNumber,
            });
          } else {
            Toast.info(responseData.msg, 1);
          }
        });
      }
    }
  }
}
